import api from './api';

export interface FornecedorDefinicao {
    id: string;
    index: number;
    numero: number;
    nome: string;
    nomeMatriz: string;
    nomeMatrizPesquisa: string;
    nomeResumido: string;
    cnpj: string;
    itemEditado: boolean;
}

export interface FornecedorResult {
    id: string;
    index: number;
    numero: number;
    nome: string;
    nomeMatriz: string;
    nomeResumido: string;
    cnpj: string;
    itemEditado: boolean;
}

export const getAllFornecedorResult = () => api.get<FornecedorResult[]>(`fornecedor`);

export const getAllFornecedor = () => api.get<FornecedorDefinicao[]>(`definicaoFornecedor/`);
export const updateFornecedor = (values: FornecedorDefinicao) => api.put<FornecedorDefinicao>(`definicaoFornecedor/${values.id}`, values)